import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/iconfont.css";
import "./assets/css/iconfont_cms.css";
import "./assets/css/public.css";
import CryptoJS from 'crypto-js'
import axios from 'axios';


const VueUeditorWrap = require('vue-ueditor-wrap') // 百度编辑器
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.use(ElementUI)


//import VueQuillEditor from 'vue-quill-editor'

// const VueQuillEditor = require('vue-quill-editor') // 编辑器
// Vue.component('vue-ueditor-wrap', VueQuillEditor)
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'  
// Vue.use(VueQuillEditor)

//引入 Froala Editor js file.
//require('froala-editor/js/froala_editor.pkgd.min')
//引入中文语言包
//require('froala-editor/js/languages/zh_cn')
//引入 Froala Editor css files.
//require('froala-editor/css/froala_editor.pkgd.min.css')
//require('font-awesome/css/font-awesome.css')
//require('froala-editor/css/froala_style.min.css')
//require("../public/static/ckeditor/config");
// Import and use Vue Froala lib.
//const jQuery = require('jquery')
//const VueFroala = require('vue-froala-wysiwyg');
//window.$ = jQuery
//Vue.use(VueFroala)


import { getCookie, setCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
Vue.config.productionTip = false;
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// router.beforeEach((to, from, next) => {
// 	if(!getCookie("menuKey")) setCookie("menuKey","M180",1000 * 60 * 60);
// 	if (getCookie("menuKey") && to.params && to.params.parentcode == getCookie("menuKey")) {
// 		return
// 	}
// 	if (to.path === '/') {
// 		next();
// 	} else {
// 		let token = localStorage.getItem('token');
// 		//console.log(token);

// 		if (!token) {
// 			next('/');
// 		} else {
// 			next();
// 		}
// 	}
// });
//自动给同一个vue项目的所有请求添加请求头
axios.interceptors.request.use(function (config) {
	let token = localStorage.getItem('token');
	if (token) {
		config.headers['Authorization'] = 'Bearer ' + token;
	} else {
		router.push('/');
	}
	return config;
});
axios.interceptors.response.use(
	response => {
		// IE 8-9 
		if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
			try {
				// eslint-disable-next-line no-param-reassign
				response.data = JSON.parse(response.request.responseText);
			} catch (e) {
				// ignored
			}
		}
		return response;
	}
)
new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
